(function(){
  const button = document.getElementById('relatedProductsBtn');
  const dropdown = document.getElementById('relatedProductsList');

  if (!button || !dropdown) {
    return;
  }

  button.addEventListener('click', toggleOpenDropdown);

  // Close dropdown when clicked away from dropdown
  document.addEventListener('click', function(event) {
    if (!button.contains(event.target) && !dropdown.contains(event.target)) {
      toggleOpenDropdown(false);
    }
  })

  // Close dropdown when Escape key is clicked
  document.addEventListener('keydown', function(event) {
    if (event.key.toLowerCase() === "escape") {
      toggleOpenDropdown(false);
    }
  })
  
  function toggleOpenDropdown(toggleOpen) {
    if (toggleOpen === undefined) {
      toggleOpen = button.getAttribute('aria-expanded') === "true";
    }
    if (toggleOpen) {
      dropdown.setAttribute('aria-hidden', 'false');
      dropdown.removeAttribute('hidden');
    } else {
      dropdown.setAttribute('aria-hidden', 'true');
      dropdown.setAttribute('hidden', '');
    }
  }
}())